/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ComparisonsRouteImport } from './routes/comparisons'
import { Route as FieldPilotRouteImport } from './routes/fieldPilot'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as ProjectRouteImport } from './routes/project'
import { Route as RevCollabRouteImport } from './routes/revCollab'
import { Route as RevPilotRouteImport } from './routes/revPilot'
import { Route as SpecPilotRouteImport } from './routes/specPilot'
import { Route as TakeoffPilotRouteImport } from './routes/takeoffPilot'
import { Route as TrainingRouteImport } from './routes/training'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminFeedbackRouteImport } from './routes/admin.feedback'
import { Route as AdminOrganizationsRouteImport } from './routes/admin.organizations'
import { Route as AdminTrainingRouteImport } from './routes/admin.training'
import { Route as ComparisonsIndexRouteImport } from './routes/comparisons.index'
import { Route as FieldPilotIndexRouteImport } from './routes/fieldPilot.index'
import { Route as FieldPilotJobIdRouteImport } from './routes/fieldPilot.$jobId'
import { Route as FieldPilotNewRouteImport } from './routes/fieldPilot.new'
import { Route as ProjectDocumentsRouteImport } from './routes/project.documents'
import { Route as RevPilotIndexRouteImport } from './routes/revPilot.index'
import { Route as RevPilotComparisonIdRouteImport } from './routes/revPilot.$comparisonId'
import { Route as RevPilotNewRouteImport } from './routes/revPilot.new'
import { Route as SpecPilotIndexRouteImport } from './routes/specPilot.index'
import { Route as SpecPilotJobIdRouteImport } from './routes/specPilot.$jobId'
import { Route as SpecPilotNewRouteImport } from './routes/specPilot.new'
import { Route as SpecPilotTemplatesRouteImport } from './routes/specPilot.templates'
import { Route as TakeoffPilotIndexRouteImport } from './routes/takeoffPilot.index'
import { Route as TakeoffPilotJobIdRouteImport } from './routes/takeoffPilot.$jobId'
import { Route as TakeoffPilotNewRouteImport } from './routes/takeoffPilot.new'
import { Route as WorkspacesNewRouteImport } from './routes/workspaces.new'
import { Route as AdminBillingIndexRouteImport } from './routes/admin.billing.index'
import { Route as AdminBillingOrgIdRouteImport } from './routes/admin.billing.$orgId'
import { Route as AdminOrgsOrgIdRouteImport } from './routes/admin.orgs.$orgId'
import { Route as AdminRolesIndexRouteImport } from './routes/admin.roles.index'
import { Route as ProjectDocumentsDocumentIdRouteImport } from './routes/project.documents.$documentId'
import { Route as RevCollabDocumentsDocumentIdRouteImport } from './routes/revCollab.documents.$documentId'
import { Route as RevCollabRevisionsRevisionIdRouteImport } from './routes/revCollab.revisions.$revisionId'
import { Route as SpecPilotJobIdSubmittalRouteImport } from './routes/specPilot.$jobId_.submittal'
import { Route as TakeoffPilotJobIdSetupRouteImport } from './routes/takeoffPilot.$jobId_.setup'
import { Route as ProjectDocumentsDocumentIdScheduleTablesRouteImport } from './routes/project_.documents.$documentId_.scheduleTables'
import { Route as SpecPilotJobIdTablesTableIdRouteImport } from './routes/specPilot.$jobId_.tables.$tableId'
import { Route as AdminOrgsOrgIdProjectsProjectIdRouteImport } from './routes/admin.orgs.$orgId.projects.$projectId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ComparisonsRoute = ComparisonsRouteImport.update({
  id: '/comparisons',
  path: '/comparisons',
  getParentRoute: () => rootRouteImport,
} as any)
const FieldPilotRoute = FieldPilotRouteImport.update({
  id: '/fieldPilot',
  path: '/fieldPilot',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectRoute = ProjectRouteImport.update({
  id: '/project',
  path: '/project',
  getParentRoute: () => rootRouteImport,
} as any)
const RevCollabRoute = RevCollabRouteImport.update({
  id: '/revCollab',
  path: '/revCollab',
  getParentRoute: () => rootRouteImport,
} as any)
const RevPilotRoute = RevPilotRouteImport.update({
  id: '/revPilot',
  path: '/revPilot',
  getParentRoute: () => rootRouteImport,
} as any)
const SpecPilotRoute = SpecPilotRouteImport.update({
  id: '/specPilot',
  path: '/specPilot',
  getParentRoute: () => rootRouteImport,
} as any)
const TakeoffPilotRoute = TakeoffPilotRouteImport.update({
  id: '/takeoffPilot',
  path: '/takeoffPilot',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainingRoute = TrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrainingRoute = AdminTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AdminRoute,
} as any)
const ComparisonsIndexRoute = ComparisonsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ComparisonsRoute,
} as any)
const FieldPilotIndexRoute = FieldPilotIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FieldPilotRoute,
} as any)
const FieldPilotJobIdRoute = FieldPilotJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => FieldPilotRoute,
} as any)
const FieldPilotNewRoute = FieldPilotNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => FieldPilotRoute,
} as any)
const ProjectDocumentsRoute = ProjectDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => ProjectRoute,
} as any)
const RevPilotIndexRoute = RevPilotIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RevPilotRoute,
} as any)
const RevPilotComparisonIdRoute = RevPilotComparisonIdRouteImport.update({
  id: '/$comparisonId',
  path: '/$comparisonId',
  getParentRoute: () => RevPilotRoute,
} as any)
const RevPilotNewRoute = RevPilotNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => RevPilotRoute,
} as any)
const SpecPilotIndexRoute = SpecPilotIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SpecPilotRoute,
} as any)
const SpecPilotJobIdRoute = SpecPilotJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => SpecPilotRoute,
} as any)
const SpecPilotNewRoute = SpecPilotNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SpecPilotRoute,
} as any)
const SpecPilotTemplatesRoute = SpecPilotTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => SpecPilotRoute,
} as any)
const TakeoffPilotIndexRoute = TakeoffPilotIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TakeoffPilotRoute,
} as any)
const TakeoffPilotJobIdRoute = TakeoffPilotJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => TakeoffPilotRoute,
} as any)
const TakeoffPilotNewRoute = TakeoffPilotNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => TakeoffPilotRoute,
} as any)
const WorkspacesNewRoute = WorkspacesNewRouteImport.update({
  id: '/workspaces/new',
  path: '/workspaces/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingIndexRoute = AdminBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingOrgIdRoute = AdminBillingOrgIdRouteImport.update({
  id: '/billing/$orgId',
  path: '/billing/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsOrgIdRoute = AdminOrgsOrgIdRouteImport.update({
  id: '/orgs/$orgId',
  path: '/orgs/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRolesIndexRoute = AdminRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AdminRoute,
} as any)
const ProjectDocumentsDocumentIdRoute =
  ProjectDocumentsDocumentIdRouteImport.update({
    id: '/$documentId',
    path: '/$documentId',
    getParentRoute: () => ProjectDocumentsRoute,
  } as any)
const RevCollabDocumentsDocumentIdRoute =
  RevCollabDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => RevCollabRoute,
  } as any)
const RevCollabRevisionsRevisionIdRoute =
  RevCollabRevisionsRevisionIdRouteImport.update({
    id: '/revisions/$revisionId',
    path: '/revisions/$revisionId',
    getParentRoute: () => RevCollabRoute,
  } as any)
const SpecPilotJobIdSubmittalRoute = SpecPilotJobIdSubmittalRouteImport.update({
  id: '/$jobId_/submittal',
  path: '/$jobId/submittal',
  getParentRoute: () => SpecPilotRoute,
} as any)
const TakeoffPilotJobIdSetupRoute = TakeoffPilotJobIdSetupRouteImport.update({
  id: '/$jobId_/setup',
  path: '/$jobId/setup',
  getParentRoute: () => TakeoffPilotRoute,
} as any)
const ProjectDocumentsDocumentIdScheduleTablesRoute =
  ProjectDocumentsDocumentIdScheduleTablesRouteImport.update({
    id: '/project_/documents/$documentId_/scheduleTables',
    path: '/project/documents/$documentId/scheduleTables',
    getParentRoute: () => rootRouteImport,
  } as any)
const SpecPilotJobIdTablesTableIdRoute =
  SpecPilotJobIdTablesTableIdRouteImport.update({
    id: '/$jobId_/tables/$tableId',
    path: '/$jobId/tables/$tableId',
    getParentRoute: () => SpecPilotRoute,
  } as any)
const AdminOrgsOrgIdProjectsProjectIdRoute =
  AdminOrgsOrgIdProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AdminOrgsOrgIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/comparisons': typeof ComparisonsRouteWithChildren
  '/fieldPilot': typeof FieldPilotRouteWithChildren
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/organization': typeof OrganizationRoute
  '/project': typeof ProjectRouteWithChildren
  '/revCollab': typeof RevCollabRouteWithChildren
  '/revPilot': typeof RevPilotRouteWithChildren
  '/specPilot': typeof SpecPilotRouteWithChildren
  '/takeoffPilot': typeof TakeoffPilotRouteWithChildren
  '/training': typeof TrainingRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/training': typeof AdminTrainingRoute
  '/fieldPilot/$jobId': typeof FieldPilotJobIdRoute
  '/fieldPilot/new': typeof FieldPilotNewRoute
  '/project/documents': typeof ProjectDocumentsRouteWithChildren
  '/revPilot/$comparisonId': typeof RevPilotComparisonIdRoute
  '/revPilot/new': typeof RevPilotNewRoute
  '/specPilot/$jobId': typeof SpecPilotJobIdRoute
  '/specPilot/new': typeof SpecPilotNewRoute
  '/specPilot/templates': typeof SpecPilotTemplatesRoute
  '/takeoffPilot/$jobId': typeof TakeoffPilotJobIdRoute
  '/takeoffPilot/new': typeof TakeoffPilotNewRoute
  '/workspaces/new': typeof WorkspacesNewRoute
  '/admin/': typeof AdminIndexRoute
  '/comparisons/': typeof ComparisonsIndexRoute
  '/fieldPilot/': typeof FieldPilotIndexRoute
  '/revPilot/': typeof RevPilotIndexRoute
  '/specPilot/': typeof SpecPilotIndexRoute
  '/takeoffPilot/': typeof TakeoffPilotIndexRoute
  '/admin/billing/$orgId': typeof AdminBillingOrgIdRoute
  '/admin/orgs/$orgId': typeof AdminOrgsOrgIdRouteWithChildren
  '/project/documents/$documentId': typeof ProjectDocumentsDocumentIdRoute
  '/revCollab/documents/$documentId': typeof RevCollabDocumentsDocumentIdRoute
  '/revCollab/revisions/$revisionId': typeof RevCollabRevisionsRevisionIdRoute
  '/specPilot/$jobId/submittal': typeof SpecPilotJobIdSubmittalRoute
  '/takeoffPilot/$jobId/setup': typeof TakeoffPilotJobIdSetupRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/roles/': typeof AdminRolesIndexRoute
  '/project/documents/$documentId/scheduleTables': typeof ProjectDocumentsDocumentIdScheduleTablesRoute
  '/specPilot/$jobId/tables/$tableId': typeof SpecPilotJobIdTablesTableIdRoute
  '/admin/orgs/$orgId/projects/$projectId': typeof AdminOrgsOrgIdProjectsProjectIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/organization': typeof OrganizationRoute
  '/project': typeof ProjectRouteWithChildren
  '/revCollab': typeof RevCollabRouteWithChildren
  '/training': typeof TrainingRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/training': typeof AdminTrainingRoute
  '/fieldPilot/$jobId': typeof FieldPilotJobIdRoute
  '/fieldPilot/new': typeof FieldPilotNewRoute
  '/project/documents': typeof ProjectDocumentsRouteWithChildren
  '/revPilot/$comparisonId': typeof RevPilotComparisonIdRoute
  '/revPilot/new': typeof RevPilotNewRoute
  '/specPilot/$jobId': typeof SpecPilotJobIdRoute
  '/specPilot/new': typeof SpecPilotNewRoute
  '/specPilot/templates': typeof SpecPilotTemplatesRoute
  '/takeoffPilot/$jobId': typeof TakeoffPilotJobIdRoute
  '/takeoffPilot/new': typeof TakeoffPilotNewRoute
  '/workspaces/new': typeof WorkspacesNewRoute
  '/admin': typeof AdminIndexRoute
  '/comparisons': typeof ComparisonsIndexRoute
  '/fieldPilot': typeof FieldPilotIndexRoute
  '/revPilot': typeof RevPilotIndexRoute
  '/specPilot': typeof SpecPilotIndexRoute
  '/takeoffPilot': typeof TakeoffPilotIndexRoute
  '/admin/billing/$orgId': typeof AdminBillingOrgIdRoute
  '/admin/orgs/$orgId': typeof AdminOrgsOrgIdRouteWithChildren
  '/project/documents/$documentId': typeof ProjectDocumentsDocumentIdRoute
  '/revCollab/documents/$documentId': typeof RevCollabDocumentsDocumentIdRoute
  '/revCollab/revisions/$revisionId': typeof RevCollabRevisionsRevisionIdRoute
  '/specPilot/$jobId/submittal': typeof SpecPilotJobIdSubmittalRoute
  '/takeoffPilot/$jobId/setup': typeof TakeoffPilotJobIdSetupRoute
  '/admin/billing': typeof AdminBillingIndexRoute
  '/admin/roles': typeof AdminRolesIndexRoute
  '/project/documents/$documentId/scheduleTables': typeof ProjectDocumentsDocumentIdScheduleTablesRoute
  '/specPilot/$jobId/tables/$tableId': typeof SpecPilotJobIdTablesTableIdRoute
  '/admin/orgs/$orgId/projects/$projectId': typeof AdminOrgsOrgIdProjectsProjectIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/comparisons': typeof ComparisonsRouteWithChildren
  '/fieldPilot': typeof FieldPilotRouteWithChildren
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/organization': typeof OrganizationRoute
  '/project': typeof ProjectRouteWithChildren
  '/revCollab': typeof RevCollabRouteWithChildren
  '/revPilot': typeof RevPilotRouteWithChildren
  '/specPilot': typeof SpecPilotRouteWithChildren
  '/takeoffPilot': typeof TakeoffPilotRouteWithChildren
  '/training': typeof TrainingRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/training': typeof AdminTrainingRoute
  '/fieldPilot/$jobId': typeof FieldPilotJobIdRoute
  '/fieldPilot/new': typeof FieldPilotNewRoute
  '/project/documents': typeof ProjectDocumentsRouteWithChildren
  '/revPilot/$comparisonId': typeof RevPilotComparisonIdRoute
  '/revPilot/new': typeof RevPilotNewRoute
  '/specPilot/$jobId': typeof SpecPilotJobIdRoute
  '/specPilot/new': typeof SpecPilotNewRoute
  '/specPilot/templates': typeof SpecPilotTemplatesRoute
  '/takeoffPilot/$jobId': typeof TakeoffPilotJobIdRoute
  '/takeoffPilot/new': typeof TakeoffPilotNewRoute
  '/workspaces/new': typeof WorkspacesNewRoute
  '/admin/': typeof AdminIndexRoute
  '/comparisons/': typeof ComparisonsIndexRoute
  '/fieldPilot/': typeof FieldPilotIndexRoute
  '/revPilot/': typeof RevPilotIndexRoute
  '/specPilot/': typeof SpecPilotIndexRoute
  '/takeoffPilot/': typeof TakeoffPilotIndexRoute
  '/admin/billing/$orgId': typeof AdminBillingOrgIdRoute
  '/admin/orgs/$orgId': typeof AdminOrgsOrgIdRouteWithChildren
  '/project/documents/$documentId': typeof ProjectDocumentsDocumentIdRoute
  '/revCollab/documents/$documentId': typeof RevCollabDocumentsDocumentIdRoute
  '/revCollab/revisions/$revisionId': typeof RevCollabRevisionsRevisionIdRoute
  '/specPilot/$jobId_/submittal': typeof SpecPilotJobIdSubmittalRoute
  '/takeoffPilot/$jobId_/setup': typeof TakeoffPilotJobIdSetupRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/roles/': typeof AdminRolesIndexRoute
  '/project_/documents/$documentId_/scheduleTables': typeof ProjectDocumentsDocumentIdScheduleTablesRoute
  '/specPilot/$jobId_/tables/$tableId': typeof SpecPilotJobIdTablesTableIdRoute
  '/admin/orgs/$orgId/projects/$projectId': typeof AdminOrgsOrgIdProjectsProjectIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/comparisons'
    | '/fieldPilot'
    | '/inbox'
    | '/login'
    | '/organization'
    | '/project'
    | '/revCollab'
    | '/revPilot'
    | '/specPilot'
    | '/takeoffPilot'
    | '/training'
    | '/admin/feedback'
    | '/admin/organizations'
    | '/admin/training'
    | '/fieldPilot/$jobId'
    | '/fieldPilot/new'
    | '/project/documents'
    | '/revPilot/$comparisonId'
    | '/revPilot/new'
    | '/specPilot/$jobId'
    | '/specPilot/new'
    | '/specPilot/templates'
    | '/takeoffPilot/$jobId'
    | '/takeoffPilot/new'
    | '/workspaces/new'
    | '/admin/'
    | '/comparisons/'
    | '/fieldPilot/'
    | '/revPilot/'
    | '/specPilot/'
    | '/takeoffPilot/'
    | '/admin/billing/$orgId'
    | '/admin/orgs/$orgId'
    | '/project/documents/$documentId'
    | '/revCollab/documents/$documentId'
    | '/revCollab/revisions/$revisionId'
    | '/specPilot/$jobId/submittal'
    | '/takeoffPilot/$jobId/setup'
    | '/admin/billing/'
    | '/admin/roles/'
    | '/project/documents/$documentId/scheduleTables'
    | '/specPilot/$jobId/tables/$tableId'
    | '/admin/orgs/$orgId/projects/$projectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/inbox'
    | '/login'
    | '/organization'
    | '/project'
    | '/revCollab'
    | '/training'
    | '/admin/feedback'
    | '/admin/organizations'
    | '/admin/training'
    | '/fieldPilot/$jobId'
    | '/fieldPilot/new'
    | '/project/documents'
    | '/revPilot/$comparisonId'
    | '/revPilot/new'
    | '/specPilot/$jobId'
    | '/specPilot/new'
    | '/specPilot/templates'
    | '/takeoffPilot/$jobId'
    | '/takeoffPilot/new'
    | '/workspaces/new'
    | '/admin'
    | '/comparisons'
    | '/fieldPilot'
    | '/revPilot'
    | '/specPilot'
    | '/takeoffPilot'
    | '/admin/billing/$orgId'
    | '/admin/orgs/$orgId'
    | '/project/documents/$documentId'
    | '/revCollab/documents/$documentId'
    | '/revCollab/revisions/$revisionId'
    | '/specPilot/$jobId/submittal'
    | '/takeoffPilot/$jobId/setup'
    | '/admin/billing'
    | '/admin/roles'
    | '/project/documents/$documentId/scheduleTables'
    | '/specPilot/$jobId/tables/$tableId'
    | '/admin/orgs/$orgId/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/comparisons'
    | '/fieldPilot'
    | '/inbox'
    | '/login'
    | '/organization'
    | '/project'
    | '/revCollab'
    | '/revPilot'
    | '/specPilot'
    | '/takeoffPilot'
    | '/training'
    | '/admin/feedback'
    | '/admin/organizations'
    | '/admin/training'
    | '/fieldPilot/$jobId'
    | '/fieldPilot/new'
    | '/project/documents'
    | '/revPilot/$comparisonId'
    | '/revPilot/new'
    | '/specPilot/$jobId'
    | '/specPilot/new'
    | '/specPilot/templates'
    | '/takeoffPilot/$jobId'
    | '/takeoffPilot/new'
    | '/workspaces/new'
    | '/admin/'
    | '/comparisons/'
    | '/fieldPilot/'
    | '/revPilot/'
    | '/specPilot/'
    | '/takeoffPilot/'
    | '/admin/billing/$orgId'
    | '/admin/orgs/$orgId'
    | '/project/documents/$documentId'
    | '/revCollab/documents/$documentId'
    | '/revCollab/revisions/$revisionId'
    | '/specPilot/$jobId_/submittal'
    | '/takeoffPilot/$jobId_/setup'
    | '/admin/billing/'
    | '/admin/roles/'
    | '/project_/documents/$documentId_/scheduleTables'
    | '/specPilot/$jobId_/tables/$tableId'
    | '/admin/orgs/$orgId/projects/$projectId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ComparisonsRoute: typeof ComparisonsRouteWithChildren
  FieldPilotRoute: typeof FieldPilotRouteWithChildren
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  OrganizationRoute: typeof OrganizationRoute
  ProjectRoute: typeof ProjectRouteWithChildren
  RevCollabRoute: typeof RevCollabRouteWithChildren
  RevPilotRoute: typeof RevPilotRouteWithChildren
  SpecPilotRoute: typeof SpecPilotRouteWithChildren
  TakeoffPilotRoute: typeof TakeoffPilotRouteWithChildren
  TrainingRoute: typeof TrainingRoute
  WorkspacesNewRoute: typeof WorkspacesNewRoute
  ProjectDocumentsDocumentIdScheduleTablesRoute: typeof ProjectDocumentsDocumentIdScheduleTablesRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comparisons': {
      id: '/comparisons'
      path: '/comparisons'
      fullPath: '/comparisons'
      preLoaderRoute: typeof ComparisonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fieldPilot': {
      id: '/fieldPilot'
      path: '/fieldPilot'
      fullPath: '/fieldPilot'
      preLoaderRoute: typeof FieldPilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project': {
      id: '/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof ProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/revCollab': {
      id: '/revCollab'
      path: '/revCollab'
      fullPath: '/revCollab'
      preLoaderRoute: typeof RevCollabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/revPilot': {
      id: '/revPilot'
      path: '/revPilot'
      fullPath: '/revPilot'
      preLoaderRoute: typeof RevPilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/specPilot': {
      id: '/specPilot'
      path: '/specPilot'
      fullPath: '/specPilot'
      preLoaderRoute: typeof SpecPilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/takeoffPilot': {
      id: '/takeoffPilot'
      path: '/takeoffPilot'
      fullPath: '/takeoffPilot'
      preLoaderRoute: typeof TakeoffPilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/training': {
      id: '/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof TrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/training': {
      id: '/admin/training'
      path: '/training'
      fullPath: '/admin/training'
      preLoaderRoute: typeof AdminTrainingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/comparisons/': {
      id: '/comparisons/'
      path: '/'
      fullPath: '/comparisons/'
      preLoaderRoute: typeof ComparisonsIndexRouteImport
      parentRoute: typeof ComparisonsRoute
    }
    '/fieldPilot/': {
      id: '/fieldPilot/'
      path: '/'
      fullPath: '/fieldPilot/'
      preLoaderRoute: typeof FieldPilotIndexRouteImport
      parentRoute: typeof FieldPilotRoute
    }
    '/fieldPilot/$jobId': {
      id: '/fieldPilot/$jobId'
      path: '/$jobId'
      fullPath: '/fieldPilot/$jobId'
      preLoaderRoute: typeof FieldPilotJobIdRouteImport
      parentRoute: typeof FieldPilotRoute
    }
    '/fieldPilot/new': {
      id: '/fieldPilot/new'
      path: '/new'
      fullPath: '/fieldPilot/new'
      preLoaderRoute: typeof FieldPilotNewRouteImport
      parentRoute: typeof FieldPilotRoute
    }
    '/project/documents': {
      id: '/project/documents'
      path: '/documents'
      fullPath: '/project/documents'
      preLoaderRoute: typeof ProjectDocumentsRouteImport
      parentRoute: typeof ProjectRoute
    }
    '/revPilot/': {
      id: '/revPilot/'
      path: '/'
      fullPath: '/revPilot/'
      preLoaderRoute: typeof RevPilotIndexRouteImport
      parentRoute: typeof RevPilotRoute
    }
    '/revPilot/$comparisonId': {
      id: '/revPilot/$comparisonId'
      path: '/$comparisonId'
      fullPath: '/revPilot/$comparisonId'
      preLoaderRoute: typeof RevPilotComparisonIdRouteImport
      parentRoute: typeof RevPilotRoute
    }
    '/revPilot/new': {
      id: '/revPilot/new'
      path: '/new'
      fullPath: '/revPilot/new'
      preLoaderRoute: typeof RevPilotNewRouteImport
      parentRoute: typeof RevPilotRoute
    }
    '/specPilot/': {
      id: '/specPilot/'
      path: '/'
      fullPath: '/specPilot/'
      preLoaderRoute: typeof SpecPilotIndexRouteImport
      parentRoute: typeof SpecPilotRoute
    }
    '/specPilot/$jobId': {
      id: '/specPilot/$jobId'
      path: '/$jobId'
      fullPath: '/specPilot/$jobId'
      preLoaderRoute: typeof SpecPilotJobIdRouteImport
      parentRoute: typeof SpecPilotRoute
    }
    '/specPilot/new': {
      id: '/specPilot/new'
      path: '/new'
      fullPath: '/specPilot/new'
      preLoaderRoute: typeof SpecPilotNewRouteImport
      parentRoute: typeof SpecPilotRoute
    }
    '/specPilot/templates': {
      id: '/specPilot/templates'
      path: '/templates'
      fullPath: '/specPilot/templates'
      preLoaderRoute: typeof SpecPilotTemplatesRouteImport
      parentRoute: typeof SpecPilotRoute
    }
    '/takeoffPilot/': {
      id: '/takeoffPilot/'
      path: '/'
      fullPath: '/takeoffPilot/'
      preLoaderRoute: typeof TakeoffPilotIndexRouteImport
      parentRoute: typeof TakeoffPilotRoute
    }
    '/takeoffPilot/$jobId': {
      id: '/takeoffPilot/$jobId'
      path: '/$jobId'
      fullPath: '/takeoffPilot/$jobId'
      preLoaderRoute: typeof TakeoffPilotJobIdRouteImport
      parentRoute: typeof TakeoffPilotRoute
    }
    '/takeoffPilot/new': {
      id: '/takeoffPilot/new'
      path: '/new'
      fullPath: '/takeoffPilot/new'
      preLoaderRoute: typeof TakeoffPilotNewRouteImport
      parentRoute: typeof TakeoffPilotRoute
    }
    '/workspaces/new': {
      id: '/workspaces/new'
      path: '/workspaces/new'
      fullPath: '/workspaces/new'
      preLoaderRoute: typeof WorkspacesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing/': {
      id: '/admin/billing/'
      path: '/billing'
      fullPath: '/admin/billing/'
      preLoaderRoute: typeof AdminBillingIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/billing/$orgId': {
      id: '/admin/billing/$orgId'
      path: '/billing/$orgId'
      fullPath: '/admin/billing/$orgId'
      preLoaderRoute: typeof AdminBillingOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs/$orgId': {
      id: '/admin/orgs/$orgId'
      path: '/orgs/$orgId'
      fullPath: '/admin/orgs/$orgId'
      preLoaderRoute: typeof AdminOrgsOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/roles/': {
      id: '/admin/roles/'
      path: '/roles'
      fullPath: '/admin/roles/'
      preLoaderRoute: typeof AdminRolesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/project/documents/$documentId': {
      id: '/project/documents/$documentId'
      path: '/$documentId'
      fullPath: '/project/documents/$documentId'
      preLoaderRoute: typeof ProjectDocumentsDocumentIdRouteImport
      parentRoute: typeof ProjectDocumentsRoute
    }
    '/revCollab/documents/$documentId': {
      id: '/revCollab/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/revCollab/documents/$documentId'
      preLoaderRoute: typeof RevCollabDocumentsDocumentIdRouteImport
      parentRoute: typeof RevCollabRoute
    }
    '/revCollab/revisions/$revisionId': {
      id: '/revCollab/revisions/$revisionId'
      path: '/revisions/$revisionId'
      fullPath: '/revCollab/revisions/$revisionId'
      preLoaderRoute: typeof RevCollabRevisionsRevisionIdRouteImport
      parentRoute: typeof RevCollabRoute
    }
    '/specPilot/$jobId_/submittal': {
      id: '/specPilot/$jobId_/submittal'
      path: '/$jobId/submittal'
      fullPath: '/specPilot/$jobId/submittal'
      preLoaderRoute: typeof SpecPilotJobIdSubmittalRouteImport
      parentRoute: typeof SpecPilotRoute
    }
    '/takeoffPilot/$jobId_/setup': {
      id: '/takeoffPilot/$jobId_/setup'
      path: '/$jobId/setup'
      fullPath: '/takeoffPilot/$jobId/setup'
      preLoaderRoute: typeof TakeoffPilotJobIdSetupRouteImport
      parentRoute: typeof TakeoffPilotRoute
    }
    '/project_/documents/$documentId_/scheduleTables': {
      id: '/project_/documents/$documentId_/scheduleTables'
      path: '/project/documents/$documentId/scheduleTables'
      fullPath: '/project/documents/$documentId/scheduleTables'
      preLoaderRoute: typeof ProjectDocumentsDocumentIdScheduleTablesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/specPilot/$jobId_/tables/$tableId': {
      id: '/specPilot/$jobId_/tables/$tableId'
      path: '/$jobId/tables/$tableId'
      fullPath: '/specPilot/$jobId/tables/$tableId'
      preLoaderRoute: typeof SpecPilotJobIdTablesTableIdRouteImport
      parentRoute: typeof SpecPilotRoute
    }
    '/admin/orgs/$orgId/projects/$projectId': {
      id: '/admin/orgs/$orgId/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/admin/orgs/$orgId/projects/$projectId'
      preLoaderRoute: typeof AdminOrgsOrgIdProjectsProjectIdRouteImport
      parentRoute: typeof AdminOrgsOrgIdRoute
    }
  }
}

interface AdminOrgsOrgIdRouteChildren {
  AdminOrgsOrgIdProjectsProjectIdRoute: typeof AdminOrgsOrgIdProjectsProjectIdRoute
}

const AdminOrgsOrgIdRouteChildren: AdminOrgsOrgIdRouteChildren = {
  AdminOrgsOrgIdProjectsProjectIdRoute: AdminOrgsOrgIdProjectsProjectIdRoute,
}

const AdminOrgsOrgIdRouteWithChildren = AdminOrgsOrgIdRoute._addFileChildren(
  AdminOrgsOrgIdRouteChildren,
)

interface AdminRouteChildren {
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminTrainingRoute: typeof AdminTrainingRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminBillingOrgIdRoute: typeof AdminBillingOrgIdRoute
  AdminOrgsOrgIdRoute: typeof AdminOrgsOrgIdRouteWithChildren
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
  AdminRolesIndexRoute: typeof AdminRolesIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminTrainingRoute: AdminTrainingRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminBillingOrgIdRoute: AdminBillingOrgIdRoute,
  AdminOrgsOrgIdRoute: AdminOrgsOrgIdRouteWithChildren,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
  AdminRolesIndexRoute: AdminRolesIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface ComparisonsRouteChildren {
  ComparisonsIndexRoute: typeof ComparisonsIndexRoute
}

const ComparisonsRouteChildren: ComparisonsRouteChildren = {
  ComparisonsIndexRoute: ComparisonsIndexRoute,
}

const ComparisonsRouteWithChildren = ComparisonsRoute._addFileChildren(
  ComparisonsRouteChildren,
)

interface FieldPilotRouteChildren {
  FieldPilotJobIdRoute: typeof FieldPilotJobIdRoute
  FieldPilotNewRoute: typeof FieldPilotNewRoute
  FieldPilotIndexRoute: typeof FieldPilotIndexRoute
}

const FieldPilotRouteChildren: FieldPilotRouteChildren = {
  FieldPilotJobIdRoute: FieldPilotJobIdRoute,
  FieldPilotNewRoute: FieldPilotNewRoute,
  FieldPilotIndexRoute: FieldPilotIndexRoute,
}

const FieldPilotRouteWithChildren = FieldPilotRoute._addFileChildren(
  FieldPilotRouteChildren,
)

interface ProjectDocumentsRouteChildren {
  ProjectDocumentsDocumentIdRoute: typeof ProjectDocumentsDocumentIdRoute
}

const ProjectDocumentsRouteChildren: ProjectDocumentsRouteChildren = {
  ProjectDocumentsDocumentIdRoute: ProjectDocumentsDocumentIdRoute,
}

const ProjectDocumentsRouteWithChildren =
  ProjectDocumentsRoute._addFileChildren(ProjectDocumentsRouteChildren)

interface ProjectRouteChildren {
  ProjectDocumentsRoute: typeof ProjectDocumentsRouteWithChildren
}

const ProjectRouteChildren: ProjectRouteChildren = {
  ProjectDocumentsRoute: ProjectDocumentsRouteWithChildren,
}

const ProjectRouteWithChildren =
  ProjectRoute._addFileChildren(ProjectRouteChildren)

interface RevCollabRouteChildren {
  RevCollabDocumentsDocumentIdRoute: typeof RevCollabDocumentsDocumentIdRoute
  RevCollabRevisionsRevisionIdRoute: typeof RevCollabRevisionsRevisionIdRoute
}

const RevCollabRouteChildren: RevCollabRouteChildren = {
  RevCollabDocumentsDocumentIdRoute: RevCollabDocumentsDocumentIdRoute,
  RevCollabRevisionsRevisionIdRoute: RevCollabRevisionsRevisionIdRoute,
}

const RevCollabRouteWithChildren = RevCollabRoute._addFileChildren(
  RevCollabRouteChildren,
)

interface RevPilotRouteChildren {
  RevPilotComparisonIdRoute: typeof RevPilotComparisonIdRoute
  RevPilotNewRoute: typeof RevPilotNewRoute
  RevPilotIndexRoute: typeof RevPilotIndexRoute
}

const RevPilotRouteChildren: RevPilotRouteChildren = {
  RevPilotComparisonIdRoute: RevPilotComparisonIdRoute,
  RevPilotNewRoute: RevPilotNewRoute,
  RevPilotIndexRoute: RevPilotIndexRoute,
}

const RevPilotRouteWithChildren = RevPilotRoute._addFileChildren(
  RevPilotRouteChildren,
)

interface SpecPilotRouteChildren {
  SpecPilotJobIdRoute: typeof SpecPilotJobIdRoute
  SpecPilotNewRoute: typeof SpecPilotNewRoute
  SpecPilotTemplatesRoute: typeof SpecPilotTemplatesRoute
  SpecPilotIndexRoute: typeof SpecPilotIndexRoute
  SpecPilotJobIdSubmittalRoute: typeof SpecPilotJobIdSubmittalRoute
  SpecPilotJobIdTablesTableIdRoute: typeof SpecPilotJobIdTablesTableIdRoute
}

const SpecPilotRouteChildren: SpecPilotRouteChildren = {
  SpecPilotJobIdRoute: SpecPilotJobIdRoute,
  SpecPilotNewRoute: SpecPilotNewRoute,
  SpecPilotTemplatesRoute: SpecPilotTemplatesRoute,
  SpecPilotIndexRoute: SpecPilotIndexRoute,
  SpecPilotJobIdSubmittalRoute: SpecPilotJobIdSubmittalRoute,
  SpecPilotJobIdTablesTableIdRoute: SpecPilotJobIdTablesTableIdRoute,
}

const SpecPilotRouteWithChildren = SpecPilotRoute._addFileChildren(
  SpecPilotRouteChildren,
)

interface TakeoffPilotRouteChildren {
  TakeoffPilotJobIdRoute: typeof TakeoffPilotJobIdRoute
  TakeoffPilotNewRoute: typeof TakeoffPilotNewRoute
  TakeoffPilotIndexRoute: typeof TakeoffPilotIndexRoute
  TakeoffPilotJobIdSetupRoute: typeof TakeoffPilotJobIdSetupRoute
}

const TakeoffPilotRouteChildren: TakeoffPilotRouteChildren = {
  TakeoffPilotJobIdRoute: TakeoffPilotJobIdRoute,
  TakeoffPilotNewRoute: TakeoffPilotNewRoute,
  TakeoffPilotIndexRoute: TakeoffPilotIndexRoute,
  TakeoffPilotJobIdSetupRoute: TakeoffPilotJobIdSetupRoute,
}

const TakeoffPilotRouteWithChildren = TakeoffPilotRoute._addFileChildren(
  TakeoffPilotRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ComparisonsRoute: ComparisonsRouteWithChildren,
  FieldPilotRoute: FieldPilotRouteWithChildren,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  OrganizationRoute: OrganizationRoute,
  ProjectRoute: ProjectRouteWithChildren,
  RevCollabRoute: RevCollabRouteWithChildren,
  RevPilotRoute: RevPilotRouteWithChildren,
  SpecPilotRoute: SpecPilotRouteWithChildren,
  TakeoffPilotRoute: TakeoffPilotRouteWithChildren,
  TrainingRoute: TrainingRoute,
  WorkspacesNewRoute: WorkspacesNewRoute,
  ProjectDocumentsDocumentIdScheduleTablesRoute:
    ProjectDocumentsDocumentIdScheduleTablesRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
